import Popup from "../components/popup";

class PopupRegisterAccount extends Popup {

  public popupRegisterAccount: HTMLElement;
  public hasShown: String | null;

  private showPopup() {
    super.onTrigger({target: 'wishlist-popup-register', size: 'large--py-0'});
    localStorage.setItem('register-popup-shown', '1');
  }

  bindings() {
    super.bindings();
    if(this.popupRegisterAccount && !this.hasShown && ['/merkliste', '/ch/merkliste', '/en/wishlist'].includes(document.location.pathname) && !document.body.classList.contains('is-user')) {
      setTimeout( () => this.showPopup(), 2000);
    }
  }

  cache() {
    super.cache();
    this.popupRegisterAccount = document.querySelector('.js-o-popup__register-account') as HTMLElement;
    this.hasShown = localStorage.getItem('register-popup-shown');
  }

  init() {
    this.selectorClass = 'register-popup';
    this.cache();
    this.bindings();
  }
}

export default PopupRegisterAccount;
